const normalizeModelsV812 = (values) =>
  [...new Set((values || []).filter(Boolean))].sort();

export const organizationEditorIdentityV812 = (organization) => {
  if (!organization) return 'new';
  const account = organization.account || {};
  return [
    account.id || 'unknown',
    account.updated_at || 0,
    organization.model_access_mode || 'rules',
    organization.log_debug_enabled === true,
    normalizeModelsV812(organization.allowed_groups).join(','),
    normalizeModelsV812(organization.excluded_models).join(','),
    normalizeModelsV812(organization.known_models).join(','),
  ].join(':');
};

export const shouldLoadOrganizationScopeV812 = ({
  open,
  hydratedIdentity,
  editorIdentity,
  groups,
}) =>
  Boolean(
    open &&
      hydratedIdentity === editorIdentity &&
      Array.isArray(groups) &&
      groups.length
  );

export const reconcileOrganizationModelsV812 = ({
  currentExcluded,
  knownModels,
  routableModels,
  editing,
}) => {
  const routable = normalizeModelsV812(routableModels);
  const excluded = normalizeModelsV812(currentExcluded);
  if (!editing) return excluded;
  const knownSet = new Set(normalizeModelsV812(knownModels));
  return normalizeModelsV812([
    ...excluded,
    ...routable.filter((model) => !knownSet.has(model)),
  ]);
};

export const organizationExclusionOptionsV812 = ({
  excludedModels,
  routableModels,
  unavailableLabel,
}) => {
  const routable = normalizeModelsV812(routableModels);
  const routableSet = new Set(routable);
  return normalizeModelsV812([...routable, ...(excludedModels || [])]).map(
    (model) => ({
      key: model,
      value: model,
      text: routableSet.has(model) ? model : `${model} (${unavailableLabel})`,
    })
  );
};

export const organizationEffectiveModelCountV812 = ({
  excludedModels,
  routableModels,
}) => {
  const excludedSet = new Set(normalizeModelsV812(excludedModels));
  return normalizeModelsV812(routableModels).filter(
    (model) => !excludedSet.has(model)
  ).length;
};
